import ReactDOM from 'react-dom/client';

import { DialogsController } from '../../components/DialogsController';
import { AppProviders } from '../../components/providers/AppProviders';

const rootElement = document.getElementById('dialogs-controller-root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <AppProviders>
      <DialogsController />
    </AppProviders>,
  );
}
